/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateServiceFunctionRequest,
  GetServiceFunctionParams,
  ListServiceFunctionsParams,
  PaginatedServiceFunctionDto,
  ServiceFunctionDto,
  ServiceFunctionId,
  UpdateServiceFunctionRequest,
} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getListServiceFunctionsUrl = (params: ListServiceFunctionsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/engineering/service-functions?${stringifiedParams}`
    : `/api/v1/engineering/service-functions`;
};

/**
 * @summary List service functions
 */
export const listServiceFunctions = async (
  params: ListServiceFunctionsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaginatedServiceFunctionDto> => {
  return customFetch<PaginatedServiceFunctionDto>(getListServiceFunctionsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getCreateServiceFunctionUrl = () => {
  return `/api/v1/engineering/service-functions`;
};

/**
 * @summary Create service function
 */
export const createServiceFunction = async (
  createServiceFunctionRequest: CreateServiceFunctionRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<ServiceFunctionId> => {
  return customFetch<ServiceFunctionId>(getCreateServiceFunctionUrl(), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(createServiceFunctionRequest),
  });
};

export const getGetServiceFunctionUrl = (
  id: ServiceFunctionId,
  params?: GetServiceFunctionParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/engineering/service-functions/${id}?${stringifiedParams}`
    : `/api/v1/engineering/service-functions/${id}`;
};

/**
 * @summary Get service function
 */
export const getServiceFunction = async (
  id: ServiceFunctionId,
  params?: GetServiceFunctionParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<ServiceFunctionDto> => {
  return customFetch<ServiceFunctionDto>(getGetServiceFunctionUrl(id, params), {
    ...options,
    method: "GET",
  });
};

export const getUpdateServiceFunctionUrl = (id: ServiceFunctionId) => {
  return `/api/v1/engineering/service-functions/${id}`;
};

/**
 * @summary Update service function
 */
export const updateServiceFunction = async (
  id: ServiceFunctionId,
  updateServiceFunctionRequest: UpdateServiceFunctionRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getUpdateServiceFunctionUrl(id), {
    ...options,
    method: "PUT",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(updateServiceFunctionRequest),
  });
};

export const getDeleteServiceFunctionUrl = (id: ServiceFunctionId) => {
  return `/api/v1/engineering/service-functions/${id}`;
};

/**
 * @summary Delete service function
 */
export const deleteServiceFunction = async (
  id: ServiceFunctionId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteServiceFunctionUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getRestoreServiceFunctionUrl = (id: ServiceFunctionId) => {
  return `/api/v1/engineering/service-functions/${id}/restore`;
};

/**
 * @summary Restore service function
 */
export const restoreServiceFunction = async (
  id: ServiceFunctionId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRestoreServiceFunctionUrl(id), {
    ...options,
    method: "POST",
  });
};
